/* Adventskalender PLUS XXL – Logo platzieren direkt auf dem großen Produktfoto (Section sp-adv-deal-b, Einstellung „Platzierung“).
   Druckfeld in cm (data-fw/fh) und Lage im Foto (data-field, % des Bildes), Höchstmaß je Veredelung (data-max, mit | getrennt).
   Ziehen mit Maus/Finger/Pfeiltasten, Ecke = Größe. Farbe anklicken zeigt das Foto in dieser Farbe. Ergebnis in [data-spdl-place-out]. */
(function () {
  var root = document.querySelector('[data-spdl]');
  var box = root && root.querySelector('[data-spdl-place]');
  if (!box || box.dataset.ready) return;
  box.dataset.ready = '1';
  var EN = root.dataset.lang === 'en';
  var fw = parseFloat(box.dataset.fw) || 30, fh = parseFloat(box.dataset.fh) || 20;
  var pf = (box.dataset.field || '40,25,19,12.7').split(',').map(parseFloat);
  var maxes = (box.dataset.max || '').split('|').map(function (s) { var p = s.split('x'); return { w: parseFloat(p[0]) || fw, h: parseFloat(p[1]) || fh }; });
  var wrap = root.querySelector('.spdl__main'), main = root.querySelector('[data-spdl-main]');
  var badge = wrap.querySelector('[data-sp-ai-badge]');
  var tog = root.querySelector('[data-spdl-ptoggle]'), togt = tog && tog.querySelector('span');
  var cur = box.dataset.pimg || (main && main.src);
  var ov = document.createElement('div');
  ov.className = 'spdl__ov'; ov.hidden = true;
  ov.innerHTML = '<div class="spdl__field" style="left:' + pf[0] + '%;top:' + pf[1] + '%;width:' + pf[2] + '%;height:' + pf[3] + '%">' +
    '<span class="spdl__flab">' + (EN ? 'Print area' : 'Druckfläche') + '</span>' +
    '<span class="spdl__dimw"><i></i><b>' + fw + ' cm</b></span><span class="spdl__dimh"><i></i><b>' + fh + ' cm</b></span>' +
    '<div class="spdl__plogo" tabindex="0" role="slider" aria-label="' + (EN ? 'Logo position, move with mouse, finger or arrow keys' : 'Logo-Position, mit Maus, Finger oder Pfeiltasten verschieben') + '">' +
    '<img alt="" hidden><span class="spdl__pph">' + (EN ? 'Your logo' : 'Dein Logo') + '</span><span class="spdl__pgrip" aria-hidden="true"></span></div></div>';
  wrap.appendChild(ov);
  var field = ov.querySelector('.spdl__field'), logo = ov.querySelector('.spdl__plogo'), img = logo.querySelector('img'), ph = logo.querySelector('.spdl__pph'), grip = logo.querySelector('.spdl__pgrip');
  var size = box.querySelector('[data-spdl-psize]'), info = box.querySelector('[data-spdl-pinfo]'), lim = box.querySelector('[data-spdl-plim]');
  var out = root.querySelector('[data-spdl-place-out]');
  var opts = Array.prototype.slice.call(root.querySelectorAll('[data-spdl-opt="1"] [data-spdl-val]'));
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-spdl-thumb]'));
  var st = { a: 1.6, pct: 100, cx: fw / 2, cy: fh / 2, mi: 0 };
  if (maxes[0] && maxes[0].w < fw) { st.cx = fw * 0.78; st.cy = fh * 0.3; }
  function nf(n) { return (Math.round(n * 10) / 10).toLocaleString(EN ? 'en-GB' : 'de-DE', { maximumFractionDigits: 1 }); }
  function fit() {
    var m = maxes[st.mi] || maxes[0] || { w: fw, h: fh };
    var mw = Math.min(m.w, fw), mh = Math.min(m.h, fh), w, h;
    if (st.a > mw / mh) { w = mw; h = mw / st.a; } else { h = mh; w = mh * st.a; }
    return { w: w, h: h, mw: mw, mh: mh };
  }
  function dims() { var f = fit(), k = st.pct / 100; return { w: f.w * k, h: f.h * k, mw: f.mw, mh: f.mh, fw0: f.w }; }
  function draw() {
    var d = dims();
    st.cx = Math.max(d.w / 2, Math.min(fw - d.w / 2, st.cx));
    st.cy = Math.max(d.h / 2, Math.min(fh - d.h / 2, st.cy));
    logo.style.width = (d.w / fw * 100) + '%'; logo.style.height = (d.h / fh * 100) + '%';
    logo.style.left = ((st.cx - d.w / 2) / fw * 100) + '%'; logo.style.top = ((st.cy - d.h / 2) / fh * 100) + '%';
    if (size) size.value = Math.round(st.pct);
    lim.textContent = (EN ? 'Print area ' : 'Druckfeld ') + nf(fw) + ' × ' + nf(fh) + ' cm · ' + (EN ? 'logo max. ' : 'Logo max. ') + nf(d.mw) + ' × ' + nf(d.mh) + ' cm';
    var t = (EN ? 'Logo approx. ' : 'Logo ca. ') + nf(d.w) + ' × ' + nf(d.h) + ' cm · ' + (EN ? 'from left ' : 'von links ') + nf(st.cx - d.w / 2) + ' cm, ' + (EN ? 'from top ' : 'von oben ') + nf(st.cy - d.h / 2) + ' cm ' + (EN ? 'in the print area' : 'im Druckfeld');
    if (!st.has) { logo.hidden = true; info.textContent = EN ? 'Upload your logo (PNG, JPG or SVG) to place it in the print area.' : 'Lade dein Logo hoch (PNG, JPG oder SVG), dann kannst du es im Druckfeld verschieben und skalieren.'; out.value = ''; return; }
    logo.hidden = false; info.textContent = t; out.value = t;
  }
  function show(on, url) {
    if (on) {
      if (url) cur = url;
      if (cur && main) { main.src = cur; main.removeAttribute('srcset'); }
      ov.hidden = false; wrap.classList.add('is-place'); if (badge) badge.hidden = true;
      thumbs.forEach(function (x) { x.classList.remove('is-on'); });
    } else { ov.hidden = true; wrap.classList.remove('is-place'); }
    if (togt) togt.textContent = on ? (EN ? 'Hide print area' : 'Druckfläche ausblenden') : (EN ? 'Show print area' : 'Druckfläche zeigen');
    if (tog) tog.setAttribute('aria-pressed', on ? 'true' : 'false');
  }
  thumbs.forEach(function (b) { b.addEventListener('click', function () { show(false); }); });
  if (tog) tog.addEventListener('click', function () { show(ov.hidden); });
  root.addEventListener('spdl:color', function (e) { if (e.detail && e.detail.b) show(true, e.detail.b); });
  opts.forEach(function (b, i) { b.addEventListener('click', function () { st.mi = i; st.pct = 100; draw(); show(true); }); });
  if (size) size.addEventListener('input', function () { st.pct = parseInt(size.value, 10) || 100; draw(); show(true); });
  var file = root.querySelector('[data-spdl-file]');
  file.addEventListener('change', function () {
    var f = file.files && file.files[0];
    if (f && /^image\/(png|jpe?g|svg\+xml|webp|gif)$/.test(f.type)) {
      img.onload = function () { st.a = (img.naturalWidth || 16) / (img.naturalHeight || 10); img.hidden = false; ph.hidden = true; st.has = true; draw(); };
      img.src = URL.createObjectURL(f);
    } else { img.hidden = true; st.has = false; draw(); }
    show(true);
  });
  /* Ziehen und Größe über die Ecke */
  var drag = null;
  logo.addEventListener('pointerdown', function (e) {
    e.preventDefault(); logo.setPointerCapture(e.pointerId);
    drag = { x: e.clientX, y: e.clientY, cx: st.cx, cy: st.cy, pct: st.pct, grip: e.target === grip };
    logo.classList.add('is-drag');
  });
  logo.addEventListener('pointermove', function (e) {
    if (!drag) return; var r = field.getBoundingClientRect();
    var dx = (e.clientX - drag.x) / r.width * fw, dy = (e.clientY - drag.y) / r.height * fh;
    if (drag.grip) { var f = fit(); var w0 = f.w * drag.pct / 100; st.pct = Math.max(15, Math.min(100, (w0 + dx * 2) / f.w * 100)); }
    else { st.cx = drag.cx + dx; st.cy = drag.cy + dy; }
    draw();
  });
  function end() { drag = null; logo.classList.remove('is-drag'); }
  logo.addEventListener('pointerup', end); logo.addEventListener('pointercancel', end);
  logo.addEventListener('keydown', function (e) {
    var s = e.shiftKey ? 2 : 0.5, k = { ArrowLeft: [-s, 0], ArrowRight: [s, 0], ArrowUp: [0, -s], ArrowDown: [0, s] }[e.key];
    if (k) { e.preventDefault(); st.cx += k[0]; st.cy += k[1]; draw(); }
  });
  box.querySelectorAll('[data-spdl-ppos]').forEach(function (b) {
    b.addEventListener('click', function () { var d = dims(), p = b.dataset.spdlPpos; st.cy = d.h / 2;
      st.cx = p === 'l' ? fw - d.w / 2 : (p === 'r' ? d.w / 2 : fw / 2); draw(); show(true); });
  });
  draw();
})();
